var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "index" }, [
    _c(
      "div",
      { ref: "bar", staticClass: "top-panel" },
      [
        _c(
          "Carousel",
          { ref: "index", staticClass: "top", attrs: { loop: "" } },
          [
            _c("CarouselItem", [
              _c("div", { staticClass: "top_carouselItem" }, [
                _c("img", {
                  attrs: { src: "/static/image/banner/banner_home.png" }
                })
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { ref: "cpzx", staticClass: "cpzx" }, [
          _c("div", { staticClass: "title" }, [_vm._v("产品中心")]),
          _vm._v(" "),
          _c("div", { staticClass: "desc" }, [_vm._v("PRODUCT CENTER")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              {
                staticClass: "bg1",
                on: {
                  click: function($event) {
                    return _vm.pushView(3, 0)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "img1",
                  attrs: { src: "/static/image/home/home_img1_product.png" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "btn-img content_item",
                  attrs: { src: "/static/image/home_btn_more@2x.png" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bg2",
                on: {
                  click: function($event) {
                    return _vm.pushView(3, 1)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "img1",
                  attrs: { src: "/static/image/home_img3_product@2x.png" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "btn-img content_item",
                  attrs: { src: "/static/image/home_btn_more@2x.png" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bg3",
                on: {
                  click: function($event) {
                    return _vm.pushView(3, 2)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "img1",
                  attrs: { src: "/static/image/home_img2_product@2x.png" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "btn-img content_item",
                  attrs: { src: "/static/image/home_btn_more@2x.png" }
                })
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { ref: "hxjs", staticClass: "hxjs" }, [
          _c("div", { staticClass: "title" }, [_vm._v("核心技术")]),
          _vm._v(" "),
          _c("div", { staticClass: "desc" }, [_vm._v("CORE TECHNOLOGY")]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "info",
              on: {
                click: function($event) {
                  return _vm.pushView(2, 0)
                }
              }
            },
            [
              _c("img", {
                staticClass: "btn-img content_item",
                attrs: { src: "/static/image/home_btn_more@2x.png" }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { ref: "news", staticClass: "news" }, [
          _c("div", { staticClass: "title" }, [_vm._v("新闻中心")]),
          _vm._v(" "),
          _c("div", { staticClass: "desc" }, [_vm._v("NEWS CENTER")]),
          _vm._v(" "),
          _c("div", { staticClass: "picture" }, [
            _c("div", { staticClass: "pic" }, [
              _c("img", {
                staticClass: "picImg",
                attrs: { src: "/static/image/home_img_news@2x.png" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "title_1" }, [_vm._v("公司新闻")]),
              _vm._v(" "),
              _c("div", { staticClass: "title_2" }, [
                _vm._v(
                  "\n            晨新医疗以质量为基石，创新为航标，坚守对卓越品质与前沿技术的追求\n          "
                )
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "image btn-img content_item",
                attrs: { src: "/static/image/home_btn_more@2x.png" },
                on: {
                  click: function($event) {
                    return _vm.pushView(4, 0)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cards" },
            _vm._l(_vm.news, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "card content_item",
                  on: {
                    click: function($event) {
                      return _vm.openWeiChatView(item)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "time-p" }, [
                    _c("div", { staticClass: "time" }, [
                      _c("div", { staticClass: "day" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.day) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "year" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.month) + "月")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.year))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(item.type))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(_vm._s(item.title))
                  ])
                ]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { ref: "gywm", staticClass: "gywm" }, [
          _c("div", { staticClass: "title" }, [_vm._v("关于晨新")]),
          _vm._v(" "),
          _c("div", { staticClass: "desc" }, [_vm._v("ABOUT US")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "left" }, [
              _c("img", {
                staticClass: "icon",
                attrs: { src: "/static/image/home_slogan_aboutus@2x.png" }
              }),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "more",
                  on: {
                    click: function($event) {
                      return _vm.pushView(1, 0)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "content_item",
                    attrs: { src: "/static/image/home_btn_more@2x.png" }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(3)
          ])
        ]),
        _vm._v(" "),
        _c("Footer")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "middle" }, [
      _c("div", { staticClass: "item" }, [
        _c("img", {
          attrs: { src: "/static/image/home_icon1_technology@2x.png" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "name" }, [_vm._v("慧影影像平台")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("img", {
          attrs: { src: "/static/image/home_icon2_technology@2x.png" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "name" }, [_vm._v("慧影色彩管理平台")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("img", {
          attrs: { src: "/static/image/home_icon3_technology@2x.png" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "name" }, [_vm._v("慧影智能互联平台")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("img", {
          attrs: { src: "/static/image/home_icon4_technology@2x.png" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "name" }, [_vm._v("慧影手术导航平台")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("img", {
          attrs: { src: "/static/image/home_icon5_technology@2x.png" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "name" }, [_vm._v("慧影计算及硬件平台")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabs" }, [
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "name" }, [_vm._v("全链路")]),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [_vm._v("自主原研")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item c" }, [
        _c("div", { staticClass: "name" }, [
          _vm._v("3"),
          _c("span", [_vm._v("张")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [_vm._v("NMPA注册证")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "name" }, [
          _vm._v("20"),
          _c("span", [_vm._v("+")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [_vm._v("知识产权")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item c" }, [
        _c("div", { staticClass: "name" }, [
          _vm._v("100"),
          _c("span", [_vm._v("+")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [_vm._v("医院装机/试用")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label" }, [
      _vm._v(
        "\n            晨新医疗成立于2022年10月，是一家以创新为驱动，致力于4K+荧光+3D内窥镜成像设备的产品研发、生产、商业化的科技型企业。公司凭借强大的研发能力立足于国产医疗设备创新的前沿，实现国产化设备从“看的清-看的准-看的真”的跨越式发展。"
      ),
      _c("br"),
      _vm._v(
        "\n            研发团队实力雄厚，产品优势显现，专家+市场+资本认可度攀升，产品覆盖泌尿、肝胆、心胸、普外、妇科等七个科室。晨新全面布局精准医疗、微创医疗市场，力争成为内窥镜成像设备领域第一家科创板上市企业，为微创手术的普及和提升做出自己的贡献。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right" }, [
      _c("img", {
        staticClass: "t_image",
        attrs: { src: "/static/image/aboutus_img1@2x.png" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b56e1978", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b56e1978","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/index/index.vue
// module id = null
// module chunks = 